import { Chip, ElementsGroup } from '@otp/ui';
import { Tag } from 'src/graphql/generated/graphql';

export const TagsField = ({
  tags,
  limit = 2,
}: {
  tags: Partial<Tag>[];
  limit?: number;
}) => {
  if (!tags?.length) {
    return null;
  }

  return (
    <ElementsGroup
      elements={tags.map((tag) => (
        <Chip key={tag.id} label={tag.name} />
      ))}
      limit={limit}
    />
  );
};
